import { FormatDateTimeBr } from './date';

const DESTINATION_LABELS = Object.freeze({ ESTOQUE: 'Pode ir para estoque', RMA: 'RMA' });

/** O destino sugerido pelo checklist nunca libera a etiqueta de saída. */
export function RmaDestinationLabel(rma) {
    if (!rma?.inspected_at || !rma.inspection_destination_at || !['INSPECIONADO', 'RESOLVIDO'].includes(rma.status)) {
        return null;
    }
    return DESTINATION_LABELS[rma.inspection_destination] || null;
}

/** Reimpressão usa a identidade física já associada a este caso. */
export function RmaAssociatedLabels(labels, rma) {
    if (!rma?.id) {
        return [];
    }
    return (labels || []).filter((label) => label.status === 'ASSOCIADA' && String(label.rma_id) === String(rma.id));
}

function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/** Documento local de impressão: não altera recebimento, inspeção ou estoque. */
export function BuildRmaLabelsHtml(labels, { rma = null, kind = 'receipt' } = {}) {
    if (!['receipt', 'destination'].includes(kind)) {
        return null;
    }
    const destination = kind === 'destination' ? RmaDestinationLabel(rma) : null;
    if (kind === 'destination' && !destination) {
        return null;
    }
    const printable = rma
        ? RmaAssociatedLabels(labels, rma)
        : (labels || []).filter((label) => label.status === 'GERADA');
    if (!printable.length) {
        return null;
    }

    const blocks = printable.map((label) => {
        const orderId = rma?.external_order_id || label.external_order_id;
        const receipt = rma?.received_at;
        const heading = destination || (rma ? 'Devolvido / recebido / para inspecionar' : 'Identificação da devolução');
        const timestamp = destination
            ? `Destino confirmado em ${FormatDateTimeBr(rma.inspection_destination_at)}`
            : receipt
              ? `Recebido em ${FormatDateTimeBr(receipt)}`
              : `Etiqueta gerada em ${FormatDateTimeBr(label.created_at)}`;
        return `<div class="label">
            <div class="status">${escapeHtml(heading)}</div>
            <div class="code">${escapeHtml(label.code)}</div>
            <div class="identity">Identificação da unidade</div>
            <div class="sku">${escapeHtml(rma?.sku || 'Associar à compra no sistema')}</div>
            <div class="title">${escapeHtml((rma?.item_title || '').slice(0, 100))}</div>
            <div class="meta">${escapeHtml(orderId ? `Pedido ${orderId}` : rma ? `Caso ${rma.id}` : 'Compra ainda não identificada')}</div>
            <div class="meta">${escapeHtml(timestamp)}</div>
            ${destination ? `<div class="meta">Inspecionado em ${escapeHtml(FormatDateTimeBr(rma.inspected_at))}</div>` : ''}
        </div>`;
    });
    return `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Etiquetas de devolução</title><style>
        @page { size: 100mm 60mm; margin: 0; }
        body { margin: 0; font-family: system-ui, sans-serif; color: #000; }
        .label { width: 100mm; height: 60mm; box-sizing: border-box; padding: 4mm;
                 display: flex; flex-direction: column; justify-content: center; gap: 1mm;
                 break-inside: avoid; page-break-after: always; border: 1px dashed #ccc; }
        .label:last-child { page-break-after: auto; }
        .status { font-size: 14pt; font-weight: 800; text-transform: uppercase; line-height: 1.1; }
        .code { font-size: 24pt; font-weight: 800; font-family: monospace; letter-spacing: 1px; }
        .identity { font-size: 7pt; }
        .sku { font-size: 11pt; font-family: monospace; overflow-wrap: anywhere; }
        .title { font-size: 9pt; overflow-wrap: anywhere; }
        .meta { font-size: 8pt; overflow-wrap: anywhere; }
        @media print { .label { border: none; } }
    </style></head><body>${blocks.join('')}</body></html>`;
}
